import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nuovo-report',
  templateUrl: './nuovo-report.component.html',
  styleUrls: ['./nuovo-report.component.scss']
})
export class NuovoReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
